/*
 * @Author: your name
 * @Date: 2020-08-05 14:29:15
 * @LastEditTime: 2020-08-05 14:42:30
 * @LastEditors: Please set LastEditors
 * @Description: In User Settings Edit
 * @FilePath: /xdap-h5/src/store/form.store.js
 */
export const SET_FORM_CONFIG_BY_FORM_ID = 'SET_FORM_CONFIG_BY_FORM_ID'
export const REMOVE_FORM_CONFIG_BY_FORM_ID = 'REMOVE_FORM_CONFIG_BY_FORM_ID'

const formStore = {
  namespaced: true,
  state: {
    formConfigMap: {}
  },
  mutations: {
    [SET_FORM_CONFIG_BY_FORM_ID](state, { formId, formConfig }) {
      state.formConfigMap[formId] = formConfig
    },
    [REMOVE_FORM_CONFIG_BY_FORM_ID](state, formId) {
      delete state.formConfigMap[formId]
    }
  }
}

export default formStore
